module.exports = __webpack_public_path__ + "media/Alcohol.e886df78.svg";